import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <span>© {new Date().getFullYear()} OPTiMO-IT | Token Cost Estimator</span>
  </footer>
);

export default Footer; 